import React, { useContext } from 'react';
import css from 'styled-jsx/css';
import Link from 'next/link';
import classnames from 'classnames';
import { colors, dimensions } from './Theme';
import MatomoAsyncProvider from './services/MatomoProvider';

import { ReactComponent as FacebookLogo } from './images/facebook-logo.svg';
import { ReactComponent as InstaLogo } from './images/instagram-logo.svg';

import { FACEBOOK_LINK, INSTA_LINK } from '../../services/Configs';

const styles = css`
  .footer {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: row;
    background-color: white;
    padding: 0;
  }

  .footer__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 60px 20px;
    max-width: ${dimensions.ywgSectionMaxWidth};
    margin-bottom: 12px;
    box-sizing: border-box;
  }

  @media screen and (min-width: 960px) {
    .footer__container {
      margin: 60px auto;
      flex-direction: row;
      box-sizing: inherit;
    }
  }

  .footer__logo {
    max-width: 250px;
    width: 100%;
  }

  @media screen and (min-width: 960px) {
    .footer-separated {
      margin-right: 40px;
      padding-right: 40px;
      border-right: 1px solid ${colors.ywgVeryLightBlue};
    }
  }

  .footer__social {
    display: flex;
    flex-direction: row;
  }
  .footer__social a {
    opacity: 0.4;
    margin: 20px 15px;
  }
  .footer__links {
    display: flex;
    flex-direction: row;
    line-height: 1.375rem;
    color: ${colors.ywgNavy};
    margin: 0 0 47px;
    opacity: 0.7;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    list-style: none;
    flex-grow: 1;
    justify-content: flex-end;
  }
  .footer-link-item:not(:last-child)::after {
    margin-left: 15px;
    margin-right: 15px;
    content: ' | ';
  }
  @media screen and (max-width: 960px) {
    .footer__links {
      justify-content: center;
    }
  }
`;

const footerLinksStyles = css.resolve`
  .footer-link {
    color: ${colors.ywgNavy};
    text-decoration: none;
    cursor: pointer;
  }
  .footer-link:hover,
  .footer-link:focus {
    color: ${colors.ywgPinkishOrangeStrong};
    text-decoration: underline;
  }
  @media screen and (max-width: 960px) {
    .footer-link {
      display: inline-block;
      padding: 10px;
      font-size: 0.875rem;
    }
  }
`;

const Footer = ({ className }) => {
  const tracking = useContext(MatomoAsyncProvider.Context);
  const contactLabelClicked = () => {
    tracking.trackEvent('Support', 'Click', 'Footer label');
  };

  const footerLinks = [
    {
      text: (
        <label
          htmlFor="support-form-toggle"
          className={classnames(footerLinksStyles.className, 'footer-link')}
          tabIndex="0"
          onClick={contactLabelClicked}
        >
          Nous écrire
        </label>
      )
    },
    {
      href: '/legal/mentionslegales',
      text: 'Mentions Legales'
    },
    {
      href: '/legal/confidentialite',
      text: 'Politique de confidentialité'
    }
  ];
  return (
    <footer className={classnames('footer', className)}>
      <div className="footer__container">
        <div className="footer-separated">
          <img
            className="footer__logo"
            src="/static/images/logo-mono-baseline.svg"
            alt="Yupwego"
          />
        </div>

        <div className="footer__social">
          <a href={FACEBOOK_LINK}>
            <FacebookLogo aria-hidden="true" />
            <span className="sr-only">YUPWEGO sur Facebook</span>
          </a>
          <a href={INSTA_LINK}>
            <InstaLogo aria-hidden="true" />
            <span className="sr-only">YUPWEGO sur Instagram</span>
          </a>
        </div>

        <ul className="footer__links">
          {footerLinks.map((link, i) => (
            <li className="footer-link-item" key={`footer-link-${i}`}>
              {link.href ? (
                <Link href={link.href}>
                  <a
                    className={classnames(
                      footerLinksStyles.className,
                      'footer-link'
                    )}
                  >
                    {link.text}
                  </a>
                </Link>
              ) : (
                link.text
              )}
            </li>
          ))}
        </ul>
      </div>

      <style jsx>{styles}</style>
      {footerLinksStyles.styles}
    </footer>
  );
};

export default Footer;
